module.exports = __webpack_public_path__ + "img/banner.00f43a87.png";